import { EntitySimulation } from "../../entity/EntitySimulation";

export class DtoSimulationsPutRes extends EntitySimulation {}
